import React from "react";
import { Col, Modal, Row, Form } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { exportEmails, updateEmail } from "../../../store/emails/actions";
import { useDispatch } from "react-redux";

// Update the validation schema to validate a string (month)
const schema = yup.object().shape({
  feedback: yup.string().required("Feedback is required"),
});

export default function EmailsFeedback({
  modal_feedback,
  tog_feedback,
  setmodal_feedback,
  data,
}) {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      feedback: data.feedback,
    },
  });

  const onSubmit = (formData) => {
    dispatch(updateEmail({ ...formData, id: data.id }));

    if (!Object.keys(errors).length) {
      setmodal_feedback(false);
    }
  };

  return (
    <Modal
      isOpen={modal_feedback}
      toggle={() => {
        tog_feedback();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i className="ri-mail-line" style={{ paddingRight: 5 }}></i>
          {Object.keys(data).length !== 0 ? "Update" : "Add"} Email Feedback
        </h5>
        <button
          type="button"
          onClick={() => {
            setmodal_feedback(false);
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-2">
            <Col md="12" className="mb-2">
              <div className="field">
                <textarea
                  placeholder="Write the feedback"
                  {...register("feedback")}
                  className={`form-control ${
                    errors.feedback ? "is-invalid" : ""
                  }`}
                ></textarea>
                {errors.feedback && (
                  <div className="invalid-feedback">
                    {errors.feedback.message}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => {
                setmodal_feedback(false);
              }}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-lg btn-primary">
              Add Feedback
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
